// Source/Product-Picker-Option/Component.ts
class ProductPickerOption extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", () => {
      this.variantPicker.selectVariant(this.variantId);
      this.otherOptions.forEach((option) => {
        option.dataset.active = String(option === this);
      });
    });
  }
  get variantId() {
    return Number(this.dataset.variantId);
  }
  get otherOptions() {
    return this.parentNode.querySelectorAll(`product-picker-option`);
  }
  get variantPicker() {
    return document.querySelector(`variant-picker`);
  }
}

// Source/Product-Picker-Option/mod.ts
customElements.define("product-picker-option", ProductPickerOption);
